module.exports = __webpack_public_path__ + "static/img/xinfa.04e2ce5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/data/agency/xinfa.jpg
// module id = bQ1p
// module chunks = 1